<div class="loader-container">
    <app-loader *ngIf="loading"></app-loader>
    <app-modal-header *ngIf="modalStyle" [title]="modalTitle"></app-modal-header>
    <div [ngClass]="{ 'modal-body': modalStyle }">
        <div *ngIf="errorMessage" class="alert alert-danger d-flex align-items-center" role="alert">
            <div>{{ errorMessage }}</div>
        </div>

        <!-- Period Dropdown -->
        <div class="row mb-3">
            <div class="col-6">
                <label class="form-label">Periode</label>
                <select class="form-control" [(ngModel)]="selectedPeriod" (change)="filterLicenses()">
                    <option *ngFor="let period of periodsList" [value]="period.id">
                        {{ period.name }}
                    </option>
                </select>
            </div>
            <div class="col-6">
                <label class="form-label">Start datum</label> 
                <input
                    type="date" 
                    [(ngModel)]="item['activated_at']" 
                    class="form-control" 
                    placeholder="">
            </div>
        </div>

        <!-- Licenses List -->
        <div *ngIf="filteredLicenses.length > 0" class="row mb-3">
            <div class="col-12">
                <table class="table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Methode</th>
                            <th>Naam</th>
                            <th>Periode</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let license of filteredLicenses">
                            <td>
                                <input type="checkbox" [(ngModel)]="license.selected" />
                            </td>
                            <td>{{ license.course.name }}</td>
                            <td>{{ license.courseSection.name }}</td>
                            <td>{{ license.period.name }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Add Selected Licenses Button -->
        <div class="form-buttons">
            <button type="button" class="btn btn-primary" (click)="addSelectedLicenses()">Toevoegen</button>
        </div>
    </div>
</div>
